<!--
 * @Description: 
 * @Date: 2022-07-14 16:26:47
-->
<template>
  <div style="display: flex; align-items: center; width: 100%">
    <BaseDatePicker
      style="flex: 1"
      @change="onDateChange"
      v-model="dateValue"
      v-bind="$attrs"
      :type="type"
      :shortcuts="type === 'daterange' ? shortcuts : []"
      :disabled="disabled || isLongterm"
    ></BaseDatePicker>
    <BaseCheckbox
      style="flex-shrink: 0; margin-left: 10px"
      :disabled="disabled"
      v-model="isLongterm"
      @change="onSelectChange"
    >
      长期有效
    </BaseCheckbox>
  </div>
</template>

<script lang="ts" setup>
import { toRefs, ref, watchEffect } from 'vue';
import { BaseDatePicker, BaseCheckbox } from 'xrk-components';
import { formatter } from '@/utils';

const emit = defineEmits(['update:value']);

const props = withDefaults(
  defineProps<{
    shortcuts?: any;
    value: string | Array<any>;
    type?:
      | 'daterange'
      | 'year'
      | 'month'
      | 'date'
      | 'dates'
      | 'datetime'
      | 'week'
      | 'datetimerange'
      | 'monthrange';
    disabled?: boolean;
  }>(),
  {
    type: 'daterange',
    shortcuts: [
      {
        text: '半年',
        value: () => {
          const end = new Date();
          const start = new Date();
          end.setMonth(start.getMonth() + 6);
          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 0);
          return [start, end];
        }
      },
      {
        text: '一年',
        value: () => {
          const end = new Date();
          const start = new Date();
          end.setMonth(start.getMonth() + 12);
          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 0);
          return [start, end];
        }
      }
    ]
  }
);

const { value, type } = toRefs(props);

const dateValue = ref<string | Array<string>>('');
const isLongterm = ref(false);

const checkIsLongterm = val => {
  if (val === '长期') {
    isLongterm.value = true;
    return true;
  }
  isLongterm.value = false;
  return false;
};

watchEffect(() => {
  const isRange = Array.isArray(value.value);
  checkIsLongterm(isRange ? value.value[1] : value.value);
  if (isRange) {
    if (checkIsLongterm) {
      dateValue.value = [];
    }
    dateValue.value = (value.value as Array<any>).map(
      item => item ?? formatter.date(item)
    );
  } else {
    if (checkIsLongterm) {
      dateValue.value = '';
    }
    dateValue.value = value.value ?? formatter.date(value.value as string);
  }
});

const onSelectChange = (e: any) => {
  if (e) {
    emit(
      'update:value',
      type.value === 'daterange' ? ['长期', '长期'] : '长期'
    );
  } else {
    emit('update:value', null);
  }
};

const onDateChange = val => {
  emit('update:value', val);
};
</script>

<style scoped></style>
